import { alpha, type SxProps, type Theme } from "@mui/material/styles";
import { layout } from "../../theme/theme";

export const sidebarDrawerPaperSx: SxProps<Theme> = {
  backgroundColor: layout.sidebarBg,
  color: "#fff",
  boxShadow: "4px 0 20px rgba(26, 10, 62, 0.12)",
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};

export const sidebarBrandSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  px: 2,
  py: 2,
  flexShrink: 0
};

export const sidebarBrandLogoSx: SxProps<Theme> = {
  bgcolor: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiAvatar-img": {
    width: 20,
    height: 20,
    objectFit: "contain"
  }
};

export const sidebarBrandTitleSx: SxProps<Theme> = {
  color: "#fff",
  fontWeight: 700,
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  letterSpacing: "-0.01em"
};

export const sidebarListSx: SxProps<Theme> = {
  py: 0.5,
  px: 0.5,
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden"
};

export const sidebarNavIconWrapSx = (selected: boolean): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
  borderRadius: 1.5,
  color: "#fff",
  bgcolor: selected ? alpha("#fff", 0.2) : "transparent",
  "& .MuiSvgIcon-root": {
    fontSize: 20
  }
});

export const sidebarNavItemSx = (selected: boolean): SxProps<Theme> => ({
  mx: 1,
  my: 0.25,
  px: 1,
  py: 0.85,
  borderRadius: 1.5,
  color: "#fff",
  ...(selected
    ? {
        backgroundColor: alpha("#fff", 0.14),
        "& .MuiListItemText-primary": {
          fontWeight: 600
        }
      }
    : {
        "&:hover": {
          backgroundColor: alpha("#fff", 0.08)
        }
      })
});

export const sidebarSubNavItemSx = (selected: boolean): SxProps<Theme> => ({
  mx: 1,
  my: 0.2,
  pl: 2.5,
  pr: 1,
  py: 0.65,
  borderRadius: 1.5,
  color: "#fff",
  ...(selected
    ? {
        backgroundColor: alpha("#fff", 0.12),
        borderLeft: `3px solid ${alpha("#fff", 0.85)}`
      }
    : {
        borderLeft: "3px solid transparent",
        "&:hover": {
          backgroundColor: alpha("#fff", 0.06)
        }
      })
});

export const sidebarDividerSx: SxProps<Theme> = {
  borderColor: alpha("#fff", 0.12),
  mx: 1.5,
  flexShrink: 0
};

export const sidebarProfileCardSx: SxProps<Theme> = {
  p: 2,
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  justifyContent: "space-between",
  borderTop: `1px solid ${alpha("#fff", 0.12)}`,
  backgroundColor: alpha("#000", 0.08),
  flexShrink: 0
};

export const sidebarProfileAvatarSx: SxProps<Theme> = {
  width: 40,
  height: 40,
  border: `2px solid ${alpha("#fff", 0.3)}`,
  bgcolor: alpha("#fff", 0.15)
};

export const sidebarLogoutButtonSx: SxProps<Theme> = {
  minWidth: 0,
  p: 1,
  borderRadius: 1.5,
  color: "#fff",
  bgcolor: alpha("#fff", 0.12),
  "& .MuiSvgIcon-root": { color: "#fff" },
  "&:hover": {
    color: "#fff",
    bgcolor: alpha("#fff", 0.2),
    "& .MuiSvgIcon-root": { color: "#fff" }
  }
};
